import React from 'react';
import Img from 'gatsby-image';
import { graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';

const PostThumbnail = ({ node, index }) => (
    <div className="col-12 col-lg-4">
        <Link
            to={
                node.fields.slug.substring(0, 4) === '/gr/'
                    ? node.fields.slug.substring(0, 9) + node.fields.slug.substring(12, node.fields.slug.length)
                    : node.fields.slug.substring(0, 6) + node.fields.slug.substring(9, node.fields.slug.length)
            }
            className="card shadow-light-lg mb-6"
        >
            <div className="card-zoom">
                <Img
                    fluid={node.frontmatter.featuredImage.childImageSharp.fluid}
                    alt={node.frontmatter.title}
                    className="card-img-top"
                    style={{ height: '100%' }}
                />
            </div>
            <div className="card-body">
                <div className="shape shape-bottom-100 shape-fluid-x svg-shim text-white">
                    <svg viewBox="0 0 2880 480" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 345H1437.5H2880V0C1437.5 462.106 0 0 0 0V345Z" fill="#FFF" />
                    </svg>
                </div>
                <Link
                    to={
                        node.fields.slug.substring(0, 4) === '/gr/'
                            ? node.fields.slug.substring(0, 9) + node.fields.slug.substring(12, node.fields.slug.length)
                            : node.fields.slug.substring(0, 6) + node.fields.slug.substring(9, node.fields.slug.length)
                    }
                    className="card-meta"
                >
                    <h5 className="text-uppercase text-muted mb-1">{node.frontmatter.date}</h5>
                    <h5 className="text-secondary font-weight-bold mb-0">{node.frontmatter.title}</h5>
                </Link>
            </div>
        </Link>
    </div>
);

const BlogShowcase = ({ data }) => {
    return typeof data !== 'undefined' && typeof data.edges !== 'undefined' ? (
        data.edges.map(({ node }, index) => {
            return <PostThumbnail key={node.fields.slug + index} node={node} index={index} />;
        })
    ) : (
        <div className="text-center mt-10">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

BlogShowcase.propTypes = {
    data: PropTypes.node.isRequired
};
export default BlogShowcase;
